<template>
    <modal @modal-close="handleClose" size="small" tabindex="-1" role="dialog">
        <div class="bg-white rounded shadow-lg overflow-hidden pb-10 sm:pb-0">
            <login-form @changeForm="onFormChange" @close="handleClose" v-if="form === 'login'" />

            <register-form @changeForm="onFormChange" @close="handleClose" v-if="form === 'register'" />
        </div>
    </modal>
</template>

<script>
export default {
    props: [],

    data: () => ({
        form: 'login',
        show: false
    }),

    created() {},

    mounted() {
        this.trackFormEvent();
    },

    computed: {},

    methods: {
        onFormChange(form) {
            this.form = form;

            this.trackFormEvent();
        },

        handleClose() {
            this.$emit('close');
        },

        trackFormEvent() {
            this.trackRawEvent('view_auth_modal', {
                form : this.form
            });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
